import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { MainForm } from 'helpers/form';
import { FormWrapperStyles, WarningStyles } from '../UI/UI';

const FormMain = ({ formRef }) => {
  return (
    <FormWrapper ref={formRef}>
      <Body>
        <MainForm hideLabels gdprCss={gdprStyles} buttonCss={buttonCss} />
      </Body>
    </FormWrapper>
  );
};

const FormWrapper = styled.div`
  ${FormWrapperStyles}
  position: relative;
  max-width: 285px;
`;

const Body = styled.div`
  padding: 13px 14px 10px;
  background-color: #000000;
  border: 1px solid #b7987a;

  input {
    height: 38px;
  }
`;

const gdprStyles = css`
  ${WarningStyles}
  color: #fff;
`;

const buttonCss = css`
  max-width: 124px;
  max-height: 32px;
  border-radius: 5px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #212529;
  margin: 0 auto;
  margin-top: 15px;
  margin-right: 59px;
  background: linear-gradient(#b18e69, #bbb19c);
  padding: 4px 10px 10px;
`;

FormMain.propTypes = {
  formRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.shape({ root: PropTypes.string.isRequired }),
    }),
  ]).isRequired,
};

export default FormMain;
